import Vue from 'vue';
import Transitions from 'vue2-transitions';
import { MediaQueries } from 'vue-media-queries';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr';
import App from './App.vue';
import router from './router';
import store from './store';
// i18n
import i18n from './i18n/i18n';

// Firebase
import './vendors/firebase/firebase';

Vue.use(Transitions);

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

new Vue({
  router,
  store,
  i18n,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
